export { default as Properties } from './PropertiesIndex.vue'
